<i class="{{cssClass}} {{getVariante()}} fa-{{icon}} {{getIconThemeLabel()}} size-{{size}}">
</i>
